import { orderBy } from 'lodash-es';

import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { MwFormBaseSectionComponent } from '../section-base.component';
import { MwFormDataService } from './../@services/form-data.service';

interface NavItem {
  id: string;
  title: string;
  subTitle?: string;
  defaultSubTitle?: string;
  icon?: string;
  isOutlinedIcons?: boolean;
  isFormTitle?: boolean;
}

@Component({
  selector: 'mw-form-navigation',
  templateUrl: 'form-navigation.component.html',
  styleUrls: ['./form-navigation.component.scss'],
})
export class MwFormNavigationComponent implements OnInit, OnDestroy {
  sections: Array<MwFormBaseSectionComponent> = [];

  private unsubscribeAll$ = new Subject<void>();

  constructor(
    private readonly dataService: MwFormDataService,
    private readonly changeDetectorRef: ChangeDetectorRef
  ) {}

  ngOnDestroy(): void {
    this.unsubscribeAll$.next();
    this.unsubscribeAll$.complete();
  }

  ngOnInit(): void {
    this.dataService.sections$
      .pipe(takeUntil(this.unsubscribeAll$))
      .subscribe((sections) => {
        this.sections = orderBy(
          sections.filter((t) => !!t.title || t.isNavigationWidget === true),
          ['orderIndex', 'title']
        );
        this.changeDetectorRef.detectChanges();
      });
  }

  onScrollIntoView(id: string): void {
    document.getElementById(id).scrollIntoView();
  }
}
